module.exports = __webpack_public_path__ + "static/media/help-drag-to-fill-white.c689e7b4.png";